export default __webpack_public_path__ + "static/media/birthday-plan.f27ff522.svg";